<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">学生列表</span>
                <universityStudentList :isActive="true"></universityStudentList>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import navigator from "../../components/navigator";
import universityStudentList from "../../components/studentList/universityStudentList";

export default {
  data() {
    return {
        activeTab: "1",
        universityStudentListKey: "2"
    };
  },
  components: {
    navigator,
    universityStudentList
  },
  created() {
    this.activeTab = this.universityStudentListKey;
  },
  methods: {
    onTabClicked() {}
  },
};
</script>



// WEBPACK FOOTER //
// src/page/admin/studentList.vue